import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { Card, Box } from "@curves/ui-base";
import NavigationTabs from "@icoach/components/navigationTabs/NavigationTabs";

const NavigationTabsLayout = ({ className, tabs, children, tabsContent, ...others }) => {
	const { className: tabsContentClassName, ...othersTabsContent } = tabsContent || {};

	return (
		<Card className={clsx("tabs-content-layout", className)} {...others}>
			<Box component="header" className="page-header">
				<NavigationTabs tabs={tabs} />
			</Box>
			<Card.CardContent className={clsx(tabsContentClassName)} {...othersTabsContent}>
				{children}
			</Card.CardContent>
		</Card>
	);
};

NavigationTabsLayout.propTypes = {
	children: PropTypes.node,
	tabsContent: PropTypes.object,
	tabs: PropTypes.arrayOf(
		PropTypes.shape({
			label: PropTypes.string.isRequired,
			value: PropTypes.any.isRequired,
			icon: PropTypes.elementType,
			component: PropTypes.elementType,
			to: PropTypes.string.isRequired,
		})
	).isRequired,
};

export default NavigationTabsLayout;
